// eslint-disable-next-line import/prefer-default-export
export const GA_CHARTS_RESULTS = 10;
